export default Object.freeze({
  Yellow: 'yellow',
  GreenLight: 'green-light',
});
